<template>
  <div style="position: relative">
    <ul class="headerList">
      <div :class="{ leadList: stepList == 1 && stepType <= newGuideIdx }">
        <li>
          <label class="tit">标的:</label>
          <p>
            <span class="titCen"
              >{{ getKsubject.symbol }}-{{ getKsubject.name }}</span
            >
            <el-button size="small" @click="symbolfun('symbol')"
              >更换标的</el-button
            >
          </p>
        </li>
        <div
          class="digBox"
          v-if="stepList == 1 && stepType <= newGuideIdx"
          style="right: -106px; top: 27px"
        >
          <img src="../../assets/image/lead1.png" />
          <h3 style="margin: -12px 0 0 -17px">请选择标的</h3>
        </div>
      </div>
      <li>
        <label class="tit">时间:</label>
        <p>
          <span class="titCenData"
            >{{ headerData.startDate }}&nbsp;&nbsp;至&nbsp;&nbsp;{{
              headerData.endDate
            }}</span
          >
        </p>
      </li>
      <div :class="{ leadList: stepList == 2 && stepType <= newGuideIdx }">
        <li>
          <label class="tit">副图指标:</label>
          <p style="padding-left: 15px">
            <span
              style="padding: 0px"
              class="titCen"
              v-for="(item, idx) in dataTOList"
              :key="idx"
              >{{
                dataTOList.length == idx + 1 ? item.code : item.code + ","
              }}&nbsp;&nbsp;&nbsp;&nbsp;</span
            >
            <el-button
              size="small"
              @click="symbolfun('MASTER')"
              style="margin-left: 10px"
              >更换指标</el-button
            >
          </p>
          <el-popover placement="bottom" width="600" trigger="hover">
            <ul class="promptUl">
              <li style="margin-bottom: 10px">
                Boll:布林带，利用统计原理，求出股价的标准差及其信赖区间，从而确定股价的波动范围及未来走势，
                利用波带显示股价的安全高低价位，涉及到中轨线（MB）、上轨线（UP）和下轨线（DN）的计算，
                其中中轨线=N日的移动平均线、上轨线=中轨线+两倍的标准差、下轨线=中轨线－两倍的标准差
                <br />
              </li>
              <li style="margin-bottom: 10px">
                MACD：利用收盘价的短期指数移动平均线与长期指数移动平均线之间的聚合与分离状况，对买进、卖出时机作出研判的技术指标
                <br />
              </li>
              <li style="margin-bottom: 10px">
                RSI:
                根据供求平衡的原理，通过测量某一个期间内股价上涨总幅度占股价变化总幅度平均值的百分比，来评估多空力量的强弱程度
                <br />计算公式：N日RSI
                =N日内收盘涨幅的平均值/(N日内收盘涨幅均值+N日内收盘跌幅均值)
                ×100
                <br />
              </li>
              <li style="margin-bottom: 10px">
                CCI10:根据统计学原理，引进价格与固定期间的股价平均区间的偏离程度的概念，
                <br />强调股价平均绝对偏差在股市技术分析中的重要性
                <br />计算公式：CCI(10) = (TP-MA)/MD/0.015，其中，TP = (最高价+
                最低价 + 收盘价)/3 <br />MA = 最近10日/(TP)价的累计和/10
                <br />MD = 最近10日 (MA - TP)的绝对值的累计和/ 10
                <br />
                <br />
              </li>
              <li style="margin-bottom: 10px">
                CCI20:根据统计学原理，引进价格与固定期间的股价平均区间的偏离程度的概念，
                <br />强调股价平均绝对偏差在股市技术分析中的重要性
                <br />计算公式：CCI(20) = (TP-MA)/MD/0.015，其中，TP = (最高价/+
                最低价 + 收盘价)/3 <br />MA = 最近20日/(TP)价的累计和/20
                <br />MD = 最近20日 (MA - TP)的绝对值的累计和/ 20
                <br />
              </li>
            </ul>
            <i class="el-icon-question prompt" slot="reference"></i>
          </el-popover>
        </li>
        <div
          class="digBox"
          style="right: -96px; top: 19px"
          v-if="stepList == 2 && stepType <= newGuideIdx"
        >
          <img src="../../assets/image/lead1.png" />
          <h3>请选择副图指标</h3>
        </div>
      </div>
    </ul>
    <div class="kChart" v-if="initType">
      <!-- k线图 -->
      <div v-loading="loading">
        <div class="box-card" style="position: relative">
          <candlestick
            :getData="getData"
            :homeTitle="getKsubject.name"
            ref="kdata"
            :startTime="startTime"
            @onZoomInit="echartInit"
            :endTime="endTime"
          ></candlestick>
          <div class="cardBox" v-if="stepList == 3 && stepType <= newGuideIdx">
            <h3>向下划动滚轮查看更长时间行情数据</h3>
            <p class="cardBox_p">
              <label class="cardBox_lab1">
                <label class="cardBox_lab2"></label>
              </label>
            </p>
          </div>
        </div>
        <Card
          v-for="(item, idx) in getMACDData"
          :key="idx"
          style="margin: 30px 0"
        >
          <h3 style="font-size: 28px; font-weight: 500">
            {{ dataTOList[idx].code }}
          </h3>
          <picEchart
            :echartId="item[0].name"
            :startTime="startTime"
            :endTime="endTime"
            @onZoomInit="echartInit"
            :getpicData="item"
            class="picEchart"
            ref="picEchart"
          ></picEchart>
        </Card>
      </div>
    </div>
    <!-- 标的弹窗 -->
    <subject
      :headerData="headerData"
      ref="subject"
      @onSucceed="onSucceed"
      :symbolVisible="symbolType"
      :getKsubject="getKsubject"
    ></subject>
    <!-- 副图指标弹窗 -->
    <mastermap
      :headerData="headerData"
      ref="mastermap"
      titleVal="副图指标选择"
      @onMaster="onMaster"
      :mastermapVisible="masterType"
      :dataTOList="dataTOList"
    ></mastermap>
    <!-- 指引 -->
    <template v-if="stepType <= newGuideIdx">
      <div class="leadBox"></div>
      <!-- <div class="skip" @click="stepType='null'">跳过</div> -->
      <!-- <div class="nextStep">
        <template v-if="getKsubject.symbol && stepList == 1">
          <el-button @click="stepList--" v-if="stepList != 1">上一步</el-button>
          <el-button type="primary" v-if="stepList != 2" @click="stepList++"
            >下一步</el-button
          >
          <el-button type="primary" v-else @click="onload">完成</el-button>
        </template>
        <template v-else-if="dataTOList.length > 0">
          <el-button @click="stepList--" v-if="stepList != 1">上一步</el-button>
          <el-button type="primary" v-if="stepList != 2" @click="stepList++"
            >下一步</el-button
          >
          <el-button type="primary" v-else @click="onload">完成</el-button>
        </template>
      </div> -->
    </template>
  </div>
</template>
<script>
import candlestick from "@/views/factorAnalysis/common/echarts/homeEcharts.vue";
import TimeUtil from "@/util/TimeUtil.js";
import subject from "@/components/subjectDialog/subject.vue"; // 标的弹窗
import mastermap from "@/components/subjectDialog/mastermap.vue"; // 主图指标弹窗
import picEchart from "./common/picEchart.vue";

export default {
  components: { subject, mastermap, candlestick, picEchart },
  data() {
    return {
      // 新手指引
      stepList: 1, // 步数
      stepType: 0, // 记录进入次数
      newGuideIdx: this.$store.state.newGuideIdx, // 限制次数
      initType: false,

      startTime: "0",
      endTime: "50",
      getMACDData: [], // 幅图数据
      // 标的
      getKsubject: {},
      // 主图指标
      dataTOList: [], // 已选择数据
      masterType: false,
      // 获取k线对应指标,每次获取一个，操作方式为循环添加
      getKlineList: [],
      paramType: "0",
      symbolType: false,
      masterVisible: false,
      loading: false,
      headerData: {},
      getData: [],
      // K线图
      getKdataTo: {
        endDate: "", // 數據結束時間
        exchange: "", // 市場
        frequency: "day.1", // 频率: m.1, m.5, m.30, m.60, d.1, d.w, d.m day.month
        reinstatement: "na", // 复权,na,fward,bward
        startDate: "", // 數據開始時間
        symbol: "", // 标的
      },
      // 获取k线对应指标
      getKLinedata: {
        getKDataTO: {
          endDate: "",
          exchange: "",
          frequency: "day.1",
          reinstatement: "na",
          startDate: "",
          symbol: "",
        },
        indexName: "", // 指标名稱
      },
    };
  },
  methods: {
    // 完成
    onload() {
      this.initType = true;
      this.stepType = "null";
      this.getSubIndexParam();
    },
    echartInit(item) {
      this.startTime = item.start.toString();
      this.endTime = item.end.toString();
      this.$nextTick(() => {
        this.$refs.picEchart.forEach((item, idx) => {
          this.$refs.picEchart[idx].echartsInit();
        });
        // this.$refs.picEchart[1].echartsInit();
        this.$refs.kdata.echartsInit();
      });
    },
    // 幅图指标
    onMaster(item, type) {
      this.loading = true;
      this.masterType = false;
      if (type) {
        // this.getMACDData = item;
        this.dataTOList = item;
        if (this.stepList == 2) {
          this.onload();
        } else {
          // 初始化
          this.getKLineIndex();
        }
      }
    },
    // 标的保存
    onSucceed(item, type) {
      this.symbolType = false;
      if (type) {
        this.loading = true;
        if (this.stepList == 1) {
          this.stepList++;
        }
        this.getKsubject = item;
        // 标的参数
        this.getKdataTo.exchange = item.exchange;
        this.getKdataTo.symbol = item.symbol;
        // 主图指标
        this.getKLinedata.getKDataTO.exchange = item.exchange;
        this.getKLinedata.getKDataTO.symbol = item.symbol;
        // 初始化
        this.getKLineIndex();
      }
    },
    // 弹窗
    symbolfun(type) {
      if (type == "MASTER") {
        // 更换指标
        this.masterType = true;
        this.$refs.mastermap.ngInitList();
        // this.$refs.mastermap.paramSelect(this.dataTOList[0]); // 默认显示第一个
      } else if (type == "symbol") {
        // 标的
        this.symbolType = true;
        // this.$refs.subject.selectBtn(this.getKsubject); // 默认显示第一个
      }
      // this.getKLineIndex();
    },
    // 初始化参数
    getSubIndexParam() {
      this.$api.hubei.getSubIndexParam().then((res) => {
        if (res) {
          this.headerData = res;
          // this.getKsubject = res.codeDataTOList[0]; // 标的
          // this.dataTOList.push(res.dataPropertyTOList[0]); // 主图指标
          this.getKdataTo.endDate = res.endDate;
          this.getKdataTo.exchange = res.codeDataTOList[0].exchange;
          this.getKdataTo.symbol = res.codeDataTOList[0].symbol;
          this.getKdataTo.startDate =
            TimeUtil.aheadInit(res.startDate).slice(0, 10) + " 18:00:00"; // res.startDate;
          // 指标名称
          this.getKLinedata.getKDataTO.startDate =
            TimeUtil.aheadInit(res.startDate).slice(0, 10) + " 18:00:00";
          this.getKLinedata.getKDataTO.endDate = res.endDate;
          this.getKLinedata.getKDataTO.exchange =
            res.codeDataTOList[0].exchange;
          this.getKLinedata.getKDataTO.symbol = res.codeDataTOList[0].symbol;
          this.$nextTick(() => {
            this.$refs.subject.ngOnInit();
            this.$refs.mastermap.ngOnInit();
          });
          // 获取主图k线图
          this.getKLineIndex();
        }
      });
    },
    // 遍历获取k线对应指标
    async getKLineIndex() {
      // for dataTOList getKlineList
      this.getKlineList = [];
      this.getMACDData = [];
      for (let idx = 0; idx < this.dataTOList.length; idx++) {
        // for (const itemtoLIST of this.dataTOList) {
        this.getKLinedata.indexName = this.dataTOList[idx].code;
        await this.$api.hubei.getKLineIndex(this.getKLinedata).then((res) => {
          // this.getKlineList.push(res);
          const arrayLi = Object.keys(res.listHashMap);
          if (arrayLi.length > 0) {
            // for (const itemtoLIST of this.dataTOList) {
            const getAttr = [];
            for (const index of arrayLi) {
              getAttr.push({
                name: index,
                tradeTime: res.listHashMap[index].map((item) =>
                  item.tradeTime.slice(0, 10)
                ),
                tradeValue: res.listHashMap[index].map((item) =>
                  item.value == "nan" ? "-" : item.value
                ),
              });
            }
            this.getMACDData[idx] = getAttr;
          }
        });
      }
      // 获取主图
      this.getKData();
      // this.getKlineList =getKlineList;
    },
    // 获取主图
    getKData() {
      const than = this;
      this.loading = true;
      this.$api.hubei.getKData(this.getKdataTo).then((res) => {
        this.loading = false;
        than.getData = res.kDataTOList || [];
        if (this.initType) {
          this.$nextTick(() => {
            this.$refs.kdata.echartsInit();
          });
        }
      });
    },
    // 新手指引
    localGet() {
      if (JSON.parse(localStorage.getItem("pictureIdx"))) {
        this.stepType = Number(localStorage.getItem("pictureIdx"));
        const webSizeIdx = Number(localStorage.getItem("pictureIdx")) + 1;
        localStorage.setItem("pictureIdx", webSizeIdx);
      } else {
        localStorage.setItem("pictureIdx", 1);
      }
    },
  },
  created() {
    this.getSubIndexParam();
    // this.localGet();
    this.$ILab.StartStep("picture")
  },
};
</script>
<style lang="less" scoped>
.active {
  color: #fff;
  background: rgba(63, 152, 241, 1);
  border-radius: 4px;
  font-size: 14px;
}
.headerList {
  li {
    font-size: 14px;
    color: #666666;
    margin-bottom: 20px;
    font-family: MicrosoftYaHei;
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-box;
    .tit {
      color: #3f98f1;
      width: 64px;
      line-height: 34px;
      text-align: right;
      // display: block;
    }
    > span {
      display: inline-block;
      padding: 0 15px;
      height: 30px;
      line-height: 30px;
    }
    .titCenData {
      display: inline-block;
      padding: 0 15px;
      height: 30px;
      line-height: 30px;
    }
    .titCen {
      display: inline-block;
      padding: 0 15px;
      height: 30px;
      line-height: 30px;
      cursor: pointer;
      color: #333333;
      font-size: 14px;
    }
    // .titCen:hover {
    //   color: #fff;
    //   background: rgba(63, 152, 241, 1);
    //   border-radius: 4px;
    //   font-size: 14px;
    // }
  }
}

.box-card {
  height: 600px;
}
.picEchart {
  height: 300px;
}
// 弹窗
.symbolDialog {
  .tit {
    color: #3f98f1;
    display: inline-block;
    width: 64px;
    line-height: 34px;
  }
  .symbolDiaUl {
    li {
      display: -webkit-box;
      display: -ms-flexbox;
      display: -webkit-box;
    }
  }
  /deep/ .el-dialog__header {
    box-shadow: 0px 0px 4px 0px rgba(153, 153, 153, 1);
  }
  /deep/ .el-dialog__title {
    line-height: 24px;
    color: #57a3ef;
    font-size: 16px;
    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
    font-weight: bold;
  }
  /deep/ .el-dialog__body {
    padding: 20px;
  }
}

// 新手指引
.leadBox {
  margin-left: -16px;
  background: rgba(51, 51, 51, 0.3);
  position: fixed;
  top: 0px;
  // width: calc(100% - 64px);
  width: 100%;
  height: 100%;
  right: 0;
  bottom: 0;
}
.cardBox {
  position: absolute;
  left: 172px;
  z-index: 10;
  bottom: 84px;
  color: #fff;
  font-size: 24px;
}
.leadList {
  position: relative;
  z-index: 9;
  background: #ffffff;
  display: inline-block;
  border-radius: 10px;
  padding: 10px 10px 0 10px;
  //  pointer-events: none;
  .digBox {
    position: absolute;
    right: -225px;
    z-index: 10;
    top: 44px;
    color: #fff;
    font-size: 24px;
    h3 {
      margin-left: -80px;
    }
  }
}
.skip {
  position: absolute;
  right: 12%;
  top: 91px;
  font-size: 20px;
  color: #fff;
  cursor: pointer;
}
.nextStep {
  position: absolute;
  font-size: 21px;
  color: #fff;
  text-align: center;
  cursor: pointer;
  left: 500px;
  top: 30%;
}
.cardBox_p {
  width: 37px;
  height: 85px;
  background: #ffffff;
  border-radius: 33px;
  text-align: center;
  margin: 0 auto;
  padding: 10px;
  padding-top: 14px;
  .cardBox_lab1 {
    width: 17px;
    height: 36px;
    border-radius: 9px;
    border: 1px solid #979797;
    display: block;
  }
  .cardBox_lab2 {
    width: 14px;
    height: 14px;
    background: #d8d8d8;
    display: block;
    border-radius: 100%;
  }
}
/deep/.el-loading-spinner {
  top: 20%;
}
</style>
